$shm_hitalama_opencode_session $mol_book2
	server_url \
	session_id? \
	export_session? null
	placeholders /
	Send_icon $mol_icon_send
	Stop_icon $mol_icon_stop
	pages <= session_pages /
		<= Chat_page $mol_page
			title <= chat_title \Чат
			Head => Chat_page_head
			Body => Chat_page_body
			Foot => Chat_page_foot
			sub /
				^ chat_page_head / <= Chat_page_head
				<= Chat_page_body
				<= Chat_page_foot
			tools /
				<= Chat_model $mol_view
					attr *
						^
						title <= chat_model_hint \
					sub /
						<= chat_model_label \
				<= Chat_tokens $mol_view
					attr *
						^
						title <= context_hint \
						usage <= context_usage_level \
					sub /
						<= context_label \
				<= Chat_settings $mol_pick
					hint \Настройки чата
					trigger_content /
						<= Chat_settings_icon $mol_icon_cog_outline
					bubble_content /
						<= Chat_settings_content $mol_view
							sub /
								<= View_mode_label $mol_labeler
									title \Режим
									Content <= View_mode $mol_switch
										value? <=> view_mode? \dialog
										options *
											dialog \Диалог
											raw \Сырой
								<= Provider_label $mol_labeler
									title \Провайдер
									Content <= Provider $mol_select
										value? <=> provider_id? \
										options <= provider_options /
										dictionary <= provider_dict *
								<= Model_label $mol_labeler
									title \Модель
									Content <= Model $mol_select
										value? <=> model_id? \
										options <= model_options /
										dictionary <= model_dict *
								<= Custom_provider $mol_expander
									title \Добавить провайдера
									expanded? <=> custom_provider_expanded? false
									content /
										<= Custom_provider_content $mol_list
											rows /
												<= Custom_provider_id_label $mol_labeler
													title \Provider ID
													Content <= Custom_provider_id $mol_string
														value? <=> custom_provider_id? \
												<= Custom_provider_name_label $mol_labeler
													title \Название провайдера
													Content <= Custom_provider_name $mol_string
														value? <=> custom_provider_name? \
												<= Custom_provider_base_url_label $mol_labeler
													title \Base URL
													Content <= Custom_provider_base_url $mol_string
														value? <=> custom_provider_base_url? \
												<= Custom_provider_api_key_label $mol_labeler
													title \API key
													Content <= Custom_provider_api_key $mol_password
														value? <=> custom_provider_api_key? \
												<= Custom_provider_model_id_label $mol_labeler
													title \Model ID
													Content <= Custom_provider_model_id $mol_string
														value? <=> custom_provider_model_id? \
												<= Custom_provider_model_name_label $mol_labeler
													title \Название модели
													Content <= Custom_provider_model_name $mol_string
														value? <=> custom_provider_model_name? \
												<= Custom_provider_add $mol_button_major
													sub <= custom_provider_add_content /
													click? <=> custom_provider_add? null
								<= No_reply $mol_check_box
									title \Отправка без ответа
									checked? <=> no_reply? false
								<= Export_session $mol_button_minor
									sub /
										<= Export_session_icon $mol_icon_download
										\Скачать сессию в .md
									click? <=> export_session? null
			body /
				<= Messages_box $mol_view
					sub /
						<= Messages $mol_view
							event *
								scroll? <=> messages_scroll? null
							sub <= message_rows /
						<= Messages_new $mol_button_major
							sub /
								<= Messages_new_icon $mol_icon_arrow_down
							click? <=> messages_to_bottom? null
			foot /
				<= Prompt $mol_textarea
					value? <=> prompt? \
					submit? <=> send_button_click? null
				<= Send $mol_button_minor
					sub <= send_button_content /
					click? <=> send_button_click? null
		<= Thinking_page $mol_page
			title \Размышления
			tools /
				<= Thinking_close $mol_button_minor
					sub /
						<= Thinking_close_icon $mol_icon_close
					click? <=> thinking_close? null
			body /
				<= Thinking_status $mol_paragraph
					title <= thinking_status \
				<= Thinking_box $mol_view
					sub /
						<= Thinking_parts $mol_view
							event *
								scroll? <=> thinking_scroll? null
							sub <= thinking_step_rows /
						<= Thinking_down $mol_button_major
							sub /
								<= Thinking_down_icon $mol_icon_arrow_down
							click? <=> thinking_to_bottom? null
	Message_row* $mol_card
		theme <= message_theme* \$mol_theme_special
		attr *
			^
			role <= message_role_key* \
		sub /
			<= Message_head* $mol_view
				sub /
					<= Message_role* $mol_paragraph
						title <= message_role* \
					<= Message_thinking* $mol_link
						arg <= message_thinking_arg* *
						sub /
							<= Message_thinking_icon* $mol_icon_eye
							<= message_thinking_title* \
					<= Message_time* $mol_paragraph
						title <= message_time* \
			<= Message_text_box* $mol_view
				sub /
					<= Message_text* $shm_hitalama_text
						text <= message_text* \
			<= Message_question_options* $mol_view
				sub <= message_question_option_rows* /
	Thinking_part_row* $mol_card
		sub /
			<= Thinking_part_title* $mol_paragraph
				title <= thinking_part_title* \
			<= Thinking_part_items* $mol_view
				sub <= thinking_part_rows* /
	Thinking_text_row* $shm_hitalama_text
		text <= thinking_part_text_line_by_key* \
	Thinking_plain_row* $mol_view
		sub <= thinking_plain_row_content* /
	Thinking_tool_row* $shm_hitalama_opencode_tool_card
		name <= thinking_tool_name* \
		status <= thinking_tool_status* \
		input <= thinking_tool_input* \
		options <= thinking_tool_option_rows* /
		content <= thinking_tool_content* \
		error <= thinking_tool_error* \
	Question_option* $mol_button_minor
		title <= question_option_title* \
		click? <=> question_option_reply*? null
	Message_question_option* $mol_button_minor
		title <= message_question_option_title* \
		click? <=> message_question_option_reply*? null
